import React from "react";
import Nav from "./Nav";
import Disc from "./Disc";
import Ops from "./Ops";
import Footer from "./Footer";

const home = () => {
  return (
    <div>
      <Nav />
      <Disc />
      <Ops />
      <Footer />
    </div>
  );
};

export default home;
